/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-undef */
import '../App.css';
import React, { useEffect, useRef, useMemo, useState } from 'react';
import twitter from '../assets/twitter-.png';
import facebook from '../assets/facebook.png';
import instagram from '../assets/instagram.png';
import whatsapp from '../assets/whatsapp.png';
import navbar from '../assets/navigation-bar.png';
import wrong from '../assets/wrong.png';
import logoPic from '../assets/logo.jpg';
import ticket from '../assets/movie.png';
import ticketR from '../assets/ticketR.png';
import money from '../assets/money.png';
import Footer from '../components/footer';
import line3 from '../assets/line3.jpg';
import money2 from '../assets/1710350929.jpeg';
import user from '../assets/profile-user.png';
import calander from '../assets/calendar.png';
import coin from '../assets/coin.png';
import edit from '../assets/editing.png';
import correct from '../assets/check-mark.png';
import warning from '../assets/warning.png';

import $ from 'jquery';
import { Web3Button, Web3Modal, useWeb3Modal } from '@web3modal/react';
import { mainnet, useAccount, useContractRead, useContractReads, useContractWrite, useNetwork, usePublicClient, useSwitchNetwork, useDisconnect } from 'wagmi';
import { createPublicClient, formatEther, http, parseEther } from 'viem';
import { pulsechainV4 } from 'wagmi/chains';
import { useNavigate } from 'react-router-dom';

import contractRaffle from '../contractData/contractRaffle.json';
import contractToken from '../contractData/contractToken.json';


var Scroll = require('react-scroll');

$(window).on('load', function () {
	setTimeout(function () { // allowing 3 secs to fade out loader
		$('.page-loader').fadeOut('slow');
	}, 2000);
});

const renderer = ({ days, hours, minutes, seconds, completed }) => {
	/*	if (completed) {
			// Render a completed state
			return <Completionist />;
		} else {*/
	// Render a countdowns

	if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {

		window.location.reload(true);
		console.log("Mint Begins");
	}


	return <div class="counterBlock"><div class="days">{days}</div><div class="dots">:</div><div class="days">{hours}</div><div class="dots">:</div><div class="days">{minutes}</div><div class="dots">:</div><div class="sec">{seconds}</div></div>;
	/*	}*/
};

let signer;
var Link = Scroll.Link;
var DirectLink = Scroll.DirectLink;
var Element = Scroll.Element;
var Events = Scroll.Events;
var scroll = Scroll.animateScroll;
var scrollSpy = Scroll.scrollSpy;


const tweet = () => {
	window.open("#");
}

const discord = () => {
	window.open("#");
}

const os = () => {
	window.open("#");
}
const address = contractRaffle.address;
const ABI = contractRaffle.abi;

const addressToken = contractToken.address;
const ABIToken = contractToken.abi;

const MyRaffles = () => {

	const { open } = useWeb3Modal()
	const { chain } = useNetwork()
	const { switchNetwork } = useSwitchNetwork()
	const navigate = useNavigate();
	const [isFormValid, setIsFormValid] = useState(false);

	const { address: walletAddress } = useAccount({
		async onConnect() {
			handleConnect()
		}
	})

	const publicClient = createPublicClient({
		chain: pulsechainV4,
		transport: http()
	})

	const [_totalSupply, settotalSupply] = useState(0)
	const [statusError, setstatusError] = useState("")
	const [statusLoading, setstatusLoading] = useState("")
	const [nftMintingAmount, setnftMintingAmount] = useState(1)
	const [_publicMintMsg, set_publicMintMsg] = useState("Mint Here")
	const [_cost, set_publicSaleCost] = useState("")
	const [_wlcost, set_wlcost] = useState("")
	const [_max_per_wallet, set_max_per_wallet] = useState(10)
	const [_owner, set_owner] = useState("")
	const [myNFTWallet, setmyNFTWallet] = useState(0)
	const [_whitelist_mint_status, set_whitelist_mint_status] = useState("")
	const [_public_mint_status, set_public_mint_status] = useState("")
	const [_whitelistLimitPerWallet, set_whitelistLimitPerWallet] = useState("")
	const [_whitelistCount, set_whitelistCount] = useState("")
	const [_whitelistLimit, set_whitelistLimit] = useState("")
	const [_MAX_SUPPLY, set_MAX_SUPPLY] = useState("")
	const [_navbarOpen, set_navbarOpen] = useState(0)
	const [_RafflesList, setRafflesList] = useState(0)
	const [_TotalRaffles, setTotalRaffles] = useState(0)
	const [_connected, setConnected] = useState(false)
	const [raffles, setRaffles] = useState([]);
	const [expectedValues, setExpectedValues] = useState({});
	const [ticketIndex, setTicketIndex] = useState(null);

	const [_edit, setEdit] = useState(0);
	const [currentRaffle, setCurrentRaffle] = useState(null);
	const [_RaffleName, setRaffleName] = useState("");
	const [_Tagline, setTagline] = useState("");
	const [_EndTime, setEndTime] = useState(0);
	const [_TicketPrice, setTicketPrice] = useState("");
	const [_ExpectedValue, set_ExpectedValue] = useState("");
	const [previewImage, setPreviewImage] = useState("");
	const [errorMsg, setErrorMsg] = useState("");
	const [selectedFile, setSelectedFile] = useState(null);

	const [successR, setSuccessR] = useState("")
	const [statusErrorCreate, setStatusErrorCreate] = useState("")
	const [showErrorDiv, setShowErrorDiv] = useState(false);
	const [showNotRegistered, setShowNotRegistered] = useState("")
	const [success, setSuccess] = useState("")
	const [txnHash, setTxnHash] = useState("");

	const [ipfsImageUrl, setIpfsImageUrl] = useState("");
	const [isUploading, setIsUploading] = useState(false);
	const [imageChanged, setImageChanged] = useState(false); // Add this new state

	const [showDropdown, setShowDropdown] = useState(false);
	const dropdownRef = useRef(null);

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setShowDropdown(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	const toggleDropdown = (e) => {
		e.preventDefault();
		setShowDropdown(!showDropdown);
	}

	// Pagination state
	const [currentPage, setCurrentPage] = useState(1);
	const rafflesPerPage = 3;

	// Calculate pagination
	const indexOfLastRaffle = currentPage * rafflesPerPage;
	const indexOfFirstRaffle = indexOfLastRaffle - rafflesPerPage;
	const currentRaffles = raffles.slice(indexOfFirstRaffle, indexOfLastRaffle);
	const totalPages = Math.ceil(raffles.length / rafflesPerPage);

	// Change page
	const paginate = (pageNumber) => setCurrentPage(pageNumber);


	const { disconnect } = useDisconnect();

	// Helper function to format value for display (divide by 10^18)
	const formatDisplayValue = (value) => {
		if (!value) return "0";
		return (Number(value) / 10 ** 18).toString();
	};

	// Helper function to parse input back to wei (multiply by 10^18)
	const parseInputValue = (value) => {
		if (!value) return "0";
		return (Number(value) * 10 ** 18);
	};

	const openEdit = (raffle) => {
		setCurrentRaffle(raffle);
		setRaffleName(raffle.name);
		setTagline(raffle.tagline);
		setEndTime(raffle.endTime);
		// Initialize with the actual values (they'll be displayed divided by 10^18)
		setTicketPrice(raffle.ticketPrice);
		set_ExpectedValue(raffle.totalValue);
		setPreviewImage(raffle.imageUrl);
		setEdit(1);
	};

	const closeEdit = () => {
		setEdit(0);
		setCurrentRaffle(null);
	};

	const handleFileChange = async (event) => {
		const file = event.target.files[0];
		setErrorMsg("");

		if (!file) return;

		// Validate file type and size
		if (!file.type.match('image.*')) {
			setErrorMsg('Please select an image file (JPEG, PNG, etc.)');
			return;
		}
		if (file.size > 5 * 1024 * 1024) {
			setErrorMsg('File size must be less than 5MB');
			return;
		}

		// Create square preview
		const reader = new FileReader();
		reader.onload = (e) => {
			const img = new Image();
			img.onload = () => {
				// Create canvas for square cropping
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');

				// Size for square
				const size = Math.min(img.width, img.height);
				canvas.width = size;
				canvas.height = size;

				// Draw square image
				ctx.drawImage(
					img,
					(img.width - size) / 2,
					(img.height - size) / 2,
					size,
					size,
					0,
					0,
					size,
					size
				);

				// Create preview URL
				const previewURL = canvas.toDataURL('image/jpeg');
				setPreviewImage(previewURL);

				// If you want to upload the cropped version:
				canvas.toBlob(async (blob) => {
					const croppedFile = new File([blob], file.name, {
						type: 'image/jpeg',
						lastModified: Date.now()
					});

					// Now upload this croppedFile to IPFS
					const formData = new FormData();
					formData.append("file", croppedFile);

					try {
						setIsUploading(true);
						const response = await fetch("https://api.pinata.cloud/pinning/pinFileToIPFS", {
							method: "POST",
							headers: {
								pinata_api_key: "5bf2f2aa6f88beb93342",
								pinata_secret_api_key: "78742b68d6281df28fe0301b4bfc68e08720cd9f8c56059564f4c89c218ac6d6"
							},
							body: formData,
						});

						const result = await response.json();
						if (result.IpfsHash) {
							const ipfsUrl = `https://gateway.pinata.cloud/ipfs/${result.IpfsHash}`;
							setIpfsImageUrl(ipfsUrl);
							setImageChanged(true);
						}
					} catch (error) {
						console.error("Upload failed:", error);
						setErrorMsg("Failed to upload image");
						setPreviewImage("");
						setImageChanged(false);
					} finally {
						setIsUploading(false);
					}
				}, 'image/jpeg', 0.9);
			};
			img.src = e.target.result;
		};
		reader.readAsDataURL(file);
	};

	// Add this useEffect to reset image states when opening edit:
	useEffect(() => {
		if (_edit && currentRaffle) {
			setIpfsImageUrl("");
			setImageChanged(false);
			setPreviewImage(currentRaffle.imageUrl);
		}
	}, [_edit, currentRaffle]);

	async function closeNav() {
		set_navbarOpen(0);
	}

	async function navbarOpen() {
		set_navbarOpen(1);
	}

	//........................................//
	const contract = {
		address: address,
		abi: ABI
	}

	const contracToken = {
		address: addressToken,
		abi: ABIToken
	}

	async function handleConnect() {
		if (chain.id !== 943) {
			switchNetwork(943)
		}

		setConnected(true);
	}

	/*const { refetch: getRafflesList } = useContractRead({
		...contract,
		functionName: 'raffles', 
	})*/


	/*useEffect(() => {

		async function fetchTotalRaffles() {
			var data = await getTotalRaffles();

			setTotalRaffles(Number(data.data))
			console.log("TotalRaffles : " + data.data)
		}

		async function fetchRafflesList() {
			var data = await getRafflesList();

			setRafflesList(Number(data.data))
			console.log("RafflesList : " + data.data)
		}

		fetchTotalRaffles();
		fetchRafflesList();

		// eslint-disable-next-line no-use-before-define
	}, [_connected]);*/

	// Replace all the individual edit functions with this single one:
	const { writeAsync: editRaffle } = useContractWrite({
		...contract,
		functionName: 'editRaffle',
	});

	const { writeAsync: editValue } = useContractWrite({
		...contract,
		functionName: 'editExpectedValue',
	});

	const saveChanges = async () => {
		if (!currentRaffle) return;

		try {
			setstatusLoading(true);
			setSuccess(false);
			setStatusErrorCreate(false);
			setErrorMsg("");
			setShowErrorDiv(false);
			setShowNotRegistered(false);

			// Determine the final image URL to use
			const finalImageUrl = imageChanged && ipfsImageUrl ? ipfsImageUrl : currentRaffle.imageUrl;

			// Prepare all changes in one transaction
			const { hash } = await editRaffle({
				args: [
					currentRaffle.id,
					_RaffleName,
					_Tagline,
					_TicketPrice,
					_EndTime,
					finalImageUrl
				],
			});

			setTxnHash(hash);
			console.log("Transaction hash:", hash);

			// Wait for transaction confirmation
			const receipt = await publicClient.waitForTransactionReceipt({
				hash: hash
			});

			console.log("Transaction receipt:", receipt);

			if (receipt.status === "success") {
				setSuccess(true);
				setStatusErrorCreate(false);
				setstatusLoading(false);

				// Close popup after short delay
				setTimeout(() => {
					closeEdit();
					window.location.reload();
				}, 2000);
			} else {
				setSuccess(false);
				setStatusErrorCreate(true);
				setstatusLoading(false);
				setErrorMsg("Transaction failed");
			}

		} catch (error) {
			console.error("Transaction failed:", error);
			setstatusLoading(false);
			setSuccess(false);

			if (error.message.includes("insufficient funds")) {
				setErrorMsg("Insufficient funds for gas");
				setShowErrorDiv(true);
				setStatusErrorCreate(false);
			}
			else if (error.message.includes("User rejected")) {
				setErrorMsg("Transaction rejected by user");
				setShowErrorDiv(false);
				setStatusErrorCreate(false);
			}
			else if (error.message.includes("User not registered")) {
				setErrorMsg("User not registered");
				setShowNotRegistered(true);
				setStatusErrorCreate(false);
			}
			else {
				setErrorMsg("Transaction failed. Please try again.");
				setStatusErrorCreate(true);
			}
		}
	};

	async function closeNotificationsSuccess() {
		setSuccess(false);
		window.location.reload(true);
	}

	async function closNotifications() {
		setShowErrorDiv(false);
		setstatusError(false);
		setShowNotRegistered(false);
		setStatusErrorCreate(false);
	}

	const { refetch: getExpectedTotalValue } = useContractRead({
		...contract,
		functionName: 'expectedTotalValue',
		args: []
	})

	// ✅ Fetch total number of raffles
	const { data: totalRaffles, isError: totalError } = useContractRead({
		address: address,
		abi: ABI,
		functionName: "totalRaffles",
	});

	console.log("Total Raffles:", totalRaffles, "Error:", totalError);

	// ✅ Fetch all raffles and their images
	const { data: raffleData, isLoading, isError } = useContractReads({
		contracts: [
			{
				address: address,
				abi: ABI,
				functionName: "getUserRaffles",
				args: [walletAddress],
			}
		],
	});

	console.log("Fetched Raffle Data:", raffleData, "Error:", isError);

useEffect(() => {
  if (raffleData && raffleData[0]?.result) {
    const [raffles, images] = raffleData[0].result;
    const now = Math.floor(Date.now() / 1000); // Current time in seconds
    const formattedRaffles = [];

    for (let i = 0; i < raffles.length; i++) {
      const raffle = raffles[i];
      const imageUrl = images[i];
      const isEnded = raffle.endTime < now;

      formattedRaffles.push({
        id: raffle.raffleId.toString(),
        creator: raffle.creator,
        name: raffle.name,
        tagline: raffle.tagline,
        endTime: Number(raffle.endTime),
        ticketPrice: raffle.ticketPrice.toString(),
        imageUrl: imageUrl,
        totalTicketsIssued: Number(raffle.totalTicketsIssued),
        totalValue: raffle.totalValue.toString(),
        isStopped: raffle.isStopped, // From contract
        isEnded: isEnded // Calculated
      });
    }

    setRaffles(formattedRaffles);
  }
}, [raffleData]);

	const { writeAsync } = useContractWrite({
		...contract,
		functionName: 'mint',
		onError(error) {
			if (error.message.includes('balance')) {
				setstatusError(true)
				setstatusLoading(false)
			}
		}
	})

	async function disconnectWallet() {
		setConnected(false);
		disconnect();
		//window.location.reload(true);
	}

	async function stateMerge() {

	}

	function shortenAddress(walletAddress) {
		try {
			return _connected
				? walletAddress.slice(0, 3) + "..." + walletAddress.slice(-4)
				: "Connect";
		} catch (error) {
			console.log(error);
		}
	}

	const fetchExpectedValues = async () => {
		const values = {};
		for (let raffle of raffles) {
			try {
				const value = await publicClient.readContract({
					address: address,
					abi: ABI,
					functionName: 'expectedTotalValue',
					args: [raffle.id] // use raffle.id here
				});
				values[raffle.id] = value.toString();
			} catch (err) {
				console.error("Error fetching expected value:", err);
			}
		}
		setExpectedValues(values);
		console.log("expectedValues : " + JSON.stringify(expectedValues));
	};

	useEffect(() => {
		if (raffles.length > 0) {
			fetchExpectedValues();
		}
	}, [raffles]); // 👈 re-run when `raffles` change

	const validateForm = () => {
		return (
			_RaffleName.trim() !== '' &&
			_Tagline.trim() !== '' &&
			_TicketPrice > 0 &&
			_EndTime > Math.floor(Date.now() / 1000) && // Ensure end time is in future
			(previewImage || currentRaffle?.imageUrl) // Either new image or existing one
		);
	};

	useEffect(() => {
		setIsFormValid(validateForm());
	}, [_RaffleName, _Tagline, _TicketPrice, _EndTime, previewImage]);

	return (
		<div class="allWrap">
			<div class="light">

				{_navbarOpen < 1 ?
					(<div class="miniBarMain">
						<img className='logoPic' onClick={() => window.location.href = '/'} src={logoPic} />

						<div className='loginDiv'><button className='login'>Connect</button><img class="navbar" onClick={navbarOpen} src={navbar} /></div>
					</div>) :
					(<div class="miniBarMain">
						<img className='logoPic' onClick={() => window.location.href = '/'} src={logoPic} />

						<div className='loginDiv'><button className='login'>Connect</button><img class="navbar" onClick={closeNav} src={wrong} /></div>

					</div>)}

				<div class="headers">

					<div class="h1">

						<div class="connect">
							<div ><Link activeClass="" id="fontSize" onClick={() => window.location.href = 'raffles'}>Raffles</Link></div>
							<div className="dropdown-wrapper" ref={dropdownRef}>
								<Link
									className="nav-link with-dropdown"
									onClick={toggleDropdown}
								>
									<span id="fontSize" className={showDropdown ? 'active' : ''}>My Raffles</span>
									<svg
										className={`dropdown-icon ${showDropdown ? 'rotate' : ''}`}
										width="12"
										height="8"
										viewBox="0 0 12 8"
										fill="none"
									>
										<path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
									</svg>
								</Link>

								{showDropdown && (
									<div className="dropdown-menu">
										<Link
											className="dropdown-item"

										>
											<span className="active">Created Raffles</span>
										</Link>
										<Link
											className="dropdown-item"
											onClick={() => window.location.href = 'purchased-raffles'}
										>
											Purchased Raffles
										</Link>
									</div>
								)}
							</div>

							<div ><Link activeClass="" id="fontSize" to="" spy={true} smooth={true} duration={550}>Marketplace</Link></div>
						</div>

						<div class="logoDiv"><img onClick={() => window.location.href = '/'} src={logoPic} /></div>
						<div class="right">

							<div class="socialIcon">
								<img src={facebook} />
								<img src={instagram} />
								<img src={twitter} />
								<img src={whatsapp} />
							</div>

							{_connected ? (
								<button class="login" onClick={() => disconnectWallet()}>
									{walletAddress === "" ? "Connect" : shortenAddress(walletAddress)}
								</button>
							) : (
								<button class="login" onClick={() => { open(); }}>Connect</button>
							)}

						</div>

					</div>

				</div>

				{_navbarOpen > 0 ?
					(<div class="littleNav">
						<div class="connect">
							<div ><Link activeClass="" id="fontSize" onClick={() => window.location.href = 'Raffles'}>Raffles</Link></div>
							<div className="dropdown-wrapper" ref={dropdownRef}>
								<Link
									className="nav-link with-dropdown"
									onClick={toggleDropdown}
								>
									<span id="fontSize" className={showDropdown ? 'active' : ''}>My Raffles</span>
									<svg
										className={`dropdown-icon ${showDropdown ? 'rotate' : ''}`}
										width="12"
										height="8"
										viewBox="0 0 12 8"
										fill="none"
									>
										<path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
									</svg>
								</Link>

								{showDropdown && (
									<div className="dropdown-menu">
										<Link
											className="dropdown-item"

										>
											<span className="active">Created Raffles</span>
										</Link>
										<Link
											className="dropdown-item"
											onClick={() => window.location.href = 'purchased-raffles'}
										>
											Purchased Raffles
										</Link>
									</div>
								)}
							</div>
							<div ><Link activeClass="" id="fontSize" to="" spy={true} smooth={true} duration={550}>Marketplace</Link></div>
						</div>

						<div class="socialIcon">
							<img src={facebook} />
							<img src={instagram} />
							<img src={twitter} />
							<img src={whatsapp} />
						</div>

					</div>) : null}

				{isLoading ? (
					<div className='noR'>
						<div>Loading...</div>
					</div>
				) : (
					<>
						<div className='raffleSection'>
							{[...currentRaffles].reverse().map((raffle, index) => (

								<div className='raffleSection2' key={index}>
									<div className='raffleBox'>

										<div className='mainRIDiv'><img className='mainRI' src={raffle.imageUrl} alt={raffle.name} onClick={() => navigate(`/raffle/${raffle.id}`, { state: { raffle } })} /></div>
										<div className='raffleCon'>
											<div>
												<div className='amount'>{raffle.ticketPrice / 10 ** 18}<img src={coin} /></div>
											</div>

											<div className='tickets'>
												<img src={ticket} />
												<div>
													<div key={raffle.id}>
														{raffle.totalTicketsIssued}/{expectedValues[raffle.id] ?? '...'}
													</div>
												</div>

											</div>
										</div>

										<div className='raffleCon'>
											<div className='amountCon'>{raffle.name}<br />{raffle.tagline}</div>
										</div>

										{raffle.isStopped || raffle.isEnded ? (
											<div className='editDiv' id="closeNote">Closed</div>
										) : (
											<div className='editDiv' onClick={() => openEdit(raffle)}>
												Edit <img className='edit' src={edit} />
											</div>
										)}


										{_edit > 0 && currentRaffle && (
											<div className="popup-overlay">
												<div className="popup-container2">
													<div className="raffle-form" id="raffleForm">
														<div className='closeR' onClick={closeEdit}>✖</div>

														<div className="form-group">
															<label htmlFor="name">Raffle Name</label>
															<input
																required
																maxLength="25"
																type="text"
																id="name"
																name="name"
																onChange={(e) => setRaffleName(e.target.value)}
																value={_RaffleName}
																placeholder="Enter the name of the raffle"
															/>
														</div>

														<div className="form-group">
															<label htmlFor="raffleImage">Raffle Image</label>
															<div className="image-preview">
																<img
																	src={previewImage || currentRaffle?.imageUrl}
																	alt={previewImage ? "Preview" : "Current"}
																	style={{ width: "100px", height: "100px", objectFit: "cover" }}
																/>
															</div>
															<input
																type="file"
																id="raffleImage"
																name="raffleImage"
																accept="image/*"
																onChange={handleFileChange}
															/>
															{errorMsg && <p style={{ color: "red", marginTop: "5px" }}>{errorMsg}</p>}
														</div>

														<div className="form-group">
															<label htmlFor="tagline">Tagline</label>
															<input
																required
																maxLength="35"
																type="text"
																id="tagline"
																name="tagline"
																placeholder="Enter a catchy tagline"
																onChange={(e) => setTagline(e.target.value)}
																value={_Tagline}
															/>
														</div>

														<div className="form-group">
															<label htmlFor="endTime">End Time</label>
															<input
																type="datetime-local"
																id="endTime"
																name="endTime"
																required
																onChange={(e) => {
																	// Get selected date string from input
																	const dateStr = e.target.value;

																	// Create a date object in local time
																	const localDate = new Date(dateStr);

																	// Convert to Unix timestamp (seconds)
																	const timestamp = Math.floor(localDate.getTime() / 1000);
																	setEndTime(timestamp);
																}}
																value={_EndTime ? (() => {
																	// Create a date object from the Unix timestamp
																	const date = new Date(_EndTime * 1000);

																	// Format to YYYY-MM-DDThh:mm
																	const year = date.getFullYear();
																	const month = String(date.getMonth() + 1).padStart(2, '0');
																	const day = String(date.getDate()).padStart(2, '0');
																	const hours = String(date.getHours()).padStart(2, '0');
																	const minutes = String(date.getMinutes()).padStart(2, '0');

																	return `${year}-${month}-${day}T${hours}:${minutes}`;
																})() : ''}
																min={new Date().toISOString().slice(0, 16)}
															/>
														</div>

														<div className="form-group">
															<label htmlFor="ticketPrice">
																Ticket Price (POL) <img src={coin} />
															</label>
															<input
																required
																type="number"
																id="ticketPrice"
																name="ticketPrice"
																step="any"
																placeholder="Enter the ticket price"
																onChange={(e) => {
																	const value = e.target.value;
																	if (/^\d*\.?\d*$/.test(value)) {
																		setTicketPrice(parseInputValue(value));
																	}
																}}
																value={formatDisplayValue(_TicketPrice)}
																onKeyPress={(e) => {
																	if (e.key === '-' || !/[0-9.]/.test(e.key)) {
																		e.preventDefault();
																	}
																}}
															/>
														</div>

														<button
															className="submit-btn"
															onClick={saveChanges}
															disabled={!isFormValid || isUploading}
														>
															{isUploading ? "Uploading Image..." : "Save Changes"}
														</button>
													</div>
												</div>
											</div>
										)}

									</div>
								</div>
							))}
						</div>
						{/* Pagination controls */}
						{totalPages > 1 && (
							<div className="pagination">
								<button
									onClick={() => paginate(currentPage - 1)}
									disabled={currentPage === 1}
									className="page-button"
								>
									&laquo; Prev
								</button>

								{Array.from({ length: totalPages }, (_, i) => i + 1).map(number => (
									<button
										key={number}
										onClick={() => paginate(number)}
										className={`page-button ${currentPage === number ? 'active' : ''}`}
									>
										{number}
									</button>
								))}

								<button
									onClick={() => paginate(currentPage + 1)}
									disabled={currentPage === totalPages}
									className="page-button"
								>
									Next &raquo;
								</button>
							</div>
						)}
					</>
				)}

				{raffles.length < 1 ?
					<div className='noR'>

						<img src={ticketR} />
						<div>No raffles have been set up so far</div>

					</div>
					: null
				}

			</div >
			<img className='line2' src={line3} />

			{successR ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={closeNotificationsSuccess}>✖</div>
						<img className='correct' src={correct} />
						<div className='notificationHMsg'>Registered Successfully</div>
					</div>
					<div className='raffleCreate' onClick={openCreate}>Now you can create raffles <img src={back} /></div>

				</div> : null}

			{success ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={closeNotificationsSuccess}>✖</div>
						<img className='correct' src={correct} />
						<div className='notificationHMsg'>Raffle Edited Successfully</div>
					</div>

				</div> : null}

			{statusError ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={closNotifications}>✖</div>
						<img className='correct' src={warning} />
						<div className='notificationHMsg'>Sorry Something went wrong</div>
						<div className='notificationH2' id="error">Please try again</div>
					</div>
				</div> : null}

			{statusErrorCreate ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={closNotifications}>✖</div>
						<img className='correct' src={warning} />
						<div className='notificationHMsg'>Sorry Something went wrong</div>
						<div className='notificationH2' id="error">Please try again</div>
					</div>
				</div> : null}

			{statusLoading ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div class="loader"></div>
						<div className='notificationHMsg'>Loading</div>
					</div>
				</div> : null}

			{showErrorDiv ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={closNotifications}>✖</div>
						<img className='correct' src={warning} />
						<div className='notificationHMsg'>Insufficent Funds</div>
						<div className='notificationH2' id="error2">Please fill your wallet</div>
					</div>
				</div> : null}

			{showNotRegistered ?
				<div className="popup-overlay2">
					<div className="popup-container">
						<div className='closeR' onClick={closNotifications}>✖</div>
						<img className='correct' src={warning} />
						<div className='notificationHMsg'>User Not Registered</div>
						<div className='notificationH2' id="error2">Please register with your wallet</div>
					</div>
				</div> : null}


			<Footer />

		</div >
	)

}
export default MyRaffles;
